export const state = () => ({
  view: null,
  contractSearch: null,
  addContractSession: null,
  newContractMetadata: {},
  newContract: {},
  newContractParties: [],
  newContractPeriod: {},
  addContact: false,
  newContact: null,
})
